import { render, staticRenderFns } from "./PayerChargeForm.vue?vue&type=template&id=bbe9e4b8"
import script from "./PayerChargeForm.vue?vue&type=script&lang=js"
export * from "./PayerChargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports